import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { REVIEW_QUEUE_KEY } from "./use-review-queue";

/**
 * Re-run the ingest pipeline on an ingest-stage hold.
 * POST /v1/orders/{id}/retry-ingest
 * On success invalidates the review queue and the orders list.
 * 202 → retried (order locked or re-held for next unmapped SKU).
 * 422 order_sku_unmapped → another unmapped SKU remains.
 * 409 order_not_retryable → order state changed under us.
 */
export function useRetryIngest() {
  const queryClient = useQueryClient();
  return useMutation({
    meta: { silentError: true },
    mutationFn: async (id: string) => {
      const { data, error } = await apiClient.POST("/v1/orders/{id}/retry-ingest", {
        params: { path: { id } },
      });
      if (error) throw error;
      return data;
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: REVIEW_QUEUE_KEY });
      void queryClient.invalidateQueries({ queryKey: ["orders"] });
    },
  });
}
